export default [
  {
    path: '/home',
    component: '@/pages/home',
    title: '友邻市集',
    meta: {
      analytic: 'home',
    },
  },
  // 冗余的首页路由，用于其他入口跳转到友邻首页，此时首页判断originUrl是此路由时需要带返回按键
  {
    path: '/home-with-back',
    component: '@/pages/home',
    title: '友邻市集',
    meta: {
      analytic: 'home',
    },
  },
  { path: '/speed', component: '@/pages/speed', title: '极速达' },
  {
    path: '/product-detail/:id',
    component: '@/pages/productDetail',
    title: '商品详情',
    meta: {
      analytic: 'product_detail',
    },
  },
  {
    path: '/seckill-detail/:id',
    component: '@/pages/seckillDetail',
    title: '商品秒杀',
  },
  {
    path: '/cart',
    component: '@/pages/cart',
    title: '购物车',
    meta: {
      analytic: 'cart',
    },
  },
  {
    path: '/atmosphere-details',
    component: '@/pages/atmosphereDetails',
    title: '氛围详情',
    meta: {
      analytic: 'atmosphere_details',
    },
  },
  {
    path: '/order-details',
    component: '@/pages/order/orderDetails',
    title: '订单详情',
  },
  {
    path: '/order-list',
    component: '@/pages/order/orderList',
    title: '订单列表',
    meta: {
      analytic: 'order_list',
    },
  },
  {
    path: '/milk-book',
    component: '@/pages/milkBook',
    title: ' ', // '友邻帮你选' 不设置标题，根据接口返回设置
    meta: {
      analytic: 'milk_book',
    },
  },
  {
    path: '/confirm-order',
    component: '@/pages/order/confirmOrder',
    title: '确认订单',
    meta: {
      analytic: 'confirm_order',
    },
  },
  {
    // 秒杀下单
    path: '/seckill-confirm',
    component: '@/pages/order/confirmOrder',
    title: '确认订单',
  },
  {
    path: '/choose-address',
    component: '@/pages/chooseAddress',
    title: '选择收货地址',
  },
  {
    path: '/choose-zzr-project',
    component: '@/pages/chooseZzrProject',
    title: '选择项目',
  },
  {
    path: '/edit-address',
    component: '@/pages/editAddress',
    title: '编辑收货地址',
  },
  {
    path: '/pause-delivery',
    component: '@/pages/order/pauseDelivery',
    title: '暂停配送',
  },
  {
    path: '/after-sale',
    component: '@/pages/order/afterSale',
    title: '申请售后服务',
  },
  {
    path: `/applyAfterSaleServices/:orderId/:itemId/:afterSaleType/:logisticsType/:orderItemStatus`,
    component: '@/pages/order/newAfterSale',
    title: '申请售后服务',
  },
  {
    path: `/afterSaleServiceType/:orderId/:itemId/:orderStatus/:logisticsType/:orderItemStatus`,
    component: '@/pages/order/afterSaleType',
    title: '申请售后服务',
  },
  {
    path: `/afterSaleProgress/:orderId/:itemId`,
    component: '@/pages/order/afterSaleProgress',
    title: '售后详情',
  },
  {
    path: `/afterSaleProgress/:orderId/:itemId/:logisticsType/:orderItemStatus`,
    component: '@/pages/order/afterSaleProgress',
    title: '售后详情',
  },
  {
    path: `/expressBill/:orderId/:itemId/:afterServiceId`,
    component: '@/pages/order/newExpressBill',
    title: '售后详情',
  },
  {
    path: `/after-sale-rules`,
    component: '@/pages/order/afterSaleRules',
    title: '退款说明',
  },
  {
    path: '/coupon-list',
    component: '@/pages/order/couponList',
    title: '优惠券列表',
  },
  {
    path: '/pay-success',
    component: '@/pages/order/paySuccess',
    title: '支付成功',
    meta: {
      analytic: 'pay_success',
    },
  },
  {
    path: '/spring-festival',
    component: '@/pages/springFestival',
    title: '年货节',
  },
  // 水果节界面还是用年货节的路由免得服务端生成二维码需要修改地址
  // {
  //   path: '/spring-festival',
  //   component: '@/pages/earlySummerFruitFestival',
  //   title: '初夏水果节',
  //   meta: {
  //     analytic: 'spring_festival',
  //   },
  // },
  {
    path: '/all-category',
    component: '@/pages/allCategory',
    title: '全部分类',
    meta: {
      analytic: 'all_category',
    },
  },
  {
    path: '/category-goods',
    component: '@/pages/categoryGoods',
    title: '分类商品',
    meta: {
      analytic: 'category_goods',
    },
  },
  {
    path: '/search',
    component: '@/pages/searchProduct',
    title: '搜索',
    meta: {
      analytic: 'search',
    },
  },

  // 工程列表--魏柱
  {
    path: '/shine/plan/projectList',
    component: '@/pages/projectList',
    title: '工程列表',
  },
  // 工程列表-详情--魏柱
  {
    path: '/shine/plan/projectList/detail',
    component: '@/pages/projectList/details',
    title: '项目详情',
  },

  // 募资列表--魏柱
  {
    path: '/shine/plan/collectItems',
    component: '@/pages/projectList/collectItems',
    title: '项目详情',
  },
  // 社区排名--魏柱
  {
    path: '/shine/plan/range',
    component: '@/pages/projectList/range',
    title: '社区排名',
  },
  {
    path: '/supplier-detail',
    component: '@/pages/supplierDetail',
    title: '店铺详情',
  },
  {
    path: '/supplier-info',
    component: '@/pages/supplierInfo',
    title: '店铺信息',
  },
  {
    path: '/complaint-supplier',
    component: '@/pages/complaintSupplier',
    title: '投诉商家',
  },
  {
    path: '/buyer-info',
    component: '@/pages/order/buyerInfo',
    title: '已选客户信息',
  },
  {
    path: '/complaint-success',
    component: '@/pages/complaintSuccess',
    title: '投诉成功',
  },
  {
    path: '/comment',
    component: '@/pages/addComment',
    title: '点评一下',
  },
  {
    path: '/comment-detail',
    component: '@/pages/commentDetail',
    title: '查看点评',
  },
  {
    path: '/wanrentuan',
    component: '@/pages/wanrentuan',
    title: '万人团',
    meta: {
      analytic: 'wanrentuan',
    },
  },
  {
    path: '/comment-list/:id',
    component: '@/pages/commentList',
    title: '邻居点评',
  },
  {
    path: '/comment-success',
    component: '@/pages/commentSuccess',
    title: '点评成功',
  },
  {
    path: '/view-logistics',
    component: '@/pages/viewLogistics',
    title: '查看物流',
  },
  {
    path: '/ylplan',
    component: '@/pages/ylPlan',
    title: '友邻计划',
  },
  {
    path: '/plan-introduction',
    component: '@/pages/planIntroduction',
    title: '什么是友邻计划',
  },
  {
    path: '/plan-rules',
    component: '@/pages/communityRules',
    title: '共建美丽社区活动细则',
  },
  {
    path: '/customer-service',
    component: '@/pages/customerService',
    title: '客服',
  },
  {
    path: '/recommend-product',
    component: '@/pages/recommendProduct',
    title: '物业预缴发券',
    meta: {
      analytic: 'recommend_product',
    },
  },
  {
    path: '/join-us',
    component: '@/pages/joinUs',
    title: '加入我们',
    meta: {
      analytic: 'join_us',
    },
  },
  {
    path: '/activityTopic/:id',
    component: '@/pages/activityTopic',
    title: '专题页',
    meta: {
      analytic: 'activity_topic',
    },
  },
  {
    path: '/discountTopic',
    component: '@/pages/discountTopic',
    title: '超级秒杀日',
    meta: {
      analytic: 'discount_topic',
    },
  },
  {
    path: '/customer-list/:id',
    component: '@/pages/customerList',
    title: '客户信息列表',
  },
  {
    path: '/customer-edit/:goodsId/:userId',
    component: '@/pages/customerEdit',
    title: '客户信息编辑',
  },
];
